
import { Avatar, Group, Text, Menu, UnstyledButton } from '@mantine/core';
import { 
  IconLogout, 
  IconSettings, 
  IconUserCircle,
  IconChevronRight 
} from '@tabler/icons-react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { logout } from '../../../store/slices/authSlice';
import { useNavigate } from 'react-router-dom';

export function UserButton() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/admin/login');
  };

  // Get user's initials for avatar fallback
  const getInitials = () => {
    if (!user) return 'U';
    if (user.fullName) {
      return user.fullName
        .split(' ')
        .map((n: string) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }
    return user.username?.charAt(0).toUpperCase() || 'U';
  };

  return (
    <Menu shadow="md" width={260} position="top-end">
      <Menu.Target>
        <UnstyledButton className="w-full p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200">
          <Group>
            <Avatar
              color="exportGreen"
              radius="xl"
              size="md"
            >
              {getInitials()}
            </Avatar>
            <div className="flex-1" style={{ flex: 1 }}>
              <Text size="sm" fw={500} lineClamp={1}>
                {user?.fullName || user?.username || 'Admin User'}
              </Text>
              <Text size="xs" c="dimmed" lineClamp={1}>
                {user?.email || 'admin@thalvora.com'}
              </Text>
            </div>
            <IconChevronRight size={16} className="text-gray-500" />
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item 
          leftSection={<IconUserCircle size={16} />}
          onClick={() => navigate('/admin/profile')}
        >
          Profile
        </Menu.Item>
        <Menu.Item 
          leftSection={<IconSettings size={16} />}
          onClick={() => navigate('/admin/settings/account')}
        >
          Account Settings
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item 
          color="red" 
          leftSection={<IconLogout size={16} />}
          onClick={handleLogout}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}